
const descriptions = {
  ff: 'For complete protection and maximum coverage.',
  tf: 'For maximum peripheral vision and an unobstructed view of the road.',
  bf: 'Unobstructed peripheral vision and ultimate protection.',
  zf: 'For a completely unobstructed peripheral and vertical field-of-view.',
  ckTFFF: 'Convert your kit. Choose this option to unlock both TF and FF frame styles.',
  ckBFZF: 'Convert your kit. Choose this option to unlock both ZF and BF frame styles.'
}

const frameTypes = {
  airas: [
    {
      frameType: 'zf',
      title: 'Zero Frame',
      badge: 'ZF',
      parts: ['an'],
      description: descriptions.zf
    },
    {
      frameType: 'bf',
      title: 'Bottom Frame',
      badge: 'BF',
      parts: ['ab'],
      description: descriptions.bf
    },
    {
      conversionKit: true,
      title: 'ZF & BF',
      description: descriptions.ckBFZF
    }
  ],
  vulcans: [
    {
      frameType: 'tf',
      title: 'Top Frame (TF)',
      parts: ['vcn'],
      description: descriptions.tf
    },
    {
      frameType: 'ff',
      title: 'Full Frame (FF)',
      parts: ['vcb'],
      badge: 'Bestseller',
      badgeColor: 'blue',
      description: descriptions.ff
    },
    {
      conversionKit: true,
      title: 'TF & FF',
      description: descriptions.ckTFFF
    }
  ],
  velans: [
    {
      frameType: 'tf',
      title: 'Top Frame (TF)',
      parts: ['ven'],
      badge: 'Bestseller',
      badgeColor: 'blue',
      description: descriptions.tf
    },
    {
      frameType: 'ff',
      title: 'Full Frame (FF)',
      parts: ['veb'],
      description: descriptions.ff
    },
    {
      conversionKit: true,
      title: 'TF & FF',
      description: descriptions.ckTFFF
    }
  ]
}

export default function getFrameTypes (baseSku) {
  return frameTypes[baseSku] || []
}